<template>
    <div class="search-container">
        <head-bar title="商品搜索" :border="true" :fixed="true"></head-bar>
        <div class="search-fixed-box">
            <div class="associational-word-wrap">
                <!-- 搜索框 -->
                <div class="search-bar">
                    <div class="search-box">
                        <div class="search-input-box">
                            <input
                                type="text"
                                class="needsclick"
                                placeholder="搜索元器件型号、参数…"
                                v-model.trim="searchKey"
                                @input="searchKeyChange"
                            />
                        </div>
                        <div
                            class="search-button"
                            @click="sumbitSearchKey(searchKey)"
                        >
                            <span>搜索</span>
                        </div>
                    </div>
                </div>
                <!-- 搜索框 -->
                <!-- 联想词 -->
                <div class="associational-word" v-show="wordList.length != 0">
                    <ul class="associational-word-list">
                        <li
                            class="word-item"
                            v-for="(item, index) in wordList"
                            :key="index"
                            @click="sumbitSearchKey(item.key || '')"
                        >
                            <div class="word-item-left">
                                <span>{{ item.key }}</span>
                            </div>
                            <div class="word-item-right">
                                <span
                                    >约有{{
                                        item.searchResultCount
                                    }}条结果</span
                                >
                            </div>
                        </li>
                    </ul>
                </div>
                <!-- 联想词 -->
                <!-- 记录搜索框 -->
                <div class="record-word" v-show="wordList.length == 0">
                    <div class="caption">
                        <span>搜索记录</span>
                    </div>
                    <div class="recode-word-list">
                        <span
                            class="word-item"
                            v-for="(item, index) in recoreList"
                            @click="sumbitSearchKey(item)"
                            :key="index"
                            >{{ item }}</span
                        >
                    </div>
                </div>
                <!-- 记录搜索框 -->
            </div>
        </div>
    </div>
</template>
<script>
const SEARCH_RECORD = "seachRecord";
import { setLocalStorage, getLocalStorage } from "@/utils/localStorage";
import HeadBar from "@/components/HeadBar.vue";
import utils from "@/utils/utils";
import { isEmpty } from "@/utils/validation";
import Vue from "vue";
import { Toast } from "vant";
Vue.use(Toast);
export default {
    name: "ProductSearch",
    components: {
        HeadBar,
    },
    data() {
        return {
            searchKey: "",
            wordList: [], //搜索联想词
            recoreList: [], //搜索记录
        };
    },
    created() {
        let searchRecord = getLocalStorage(SEARCH_RECORD);
        let key = window.decodeURI(this.$route.query.key || "");
        if (!isEmpty(key)) {
            this.searchKey = key;
            this.searchKeyChange();
        }
        if (searchRecord) {
            this.recoreList = JSON.parse(searchRecord) || [];
        }
    },
    mounted() {},
    methods: {
        /**
         * @description key改变事件
         */
        searchKeyChange: utils.debounce(function() {
            let _this = this;
            let keyWord = this.searchKey || "";
            if (!keyWord) {
                keyWord = "";
            }
            this.$toast.loading({
                message: "正在搜索中...",
                duration: 0,
            });
            this.$axios
                .post(_this.$api.productApi.findAssociateWord, {
                    searchWord: keyWord,
                })
                .then((response) => {
                    let searchRecord = getLocalStorage();
                    let wordList = response.data || [];
                    _this.wordList = wordList;
                    _this.$toast.clear();
                })
                .catch(() => {
                    _this.wordList = [];
                    _this.$toast.clear();
                });
        }, 500),
        /**
         *  @description 提交搜索
         */
        sumbitSearchKey(key) {
            if (isEmpty(key)) return;
            let searchRecord = getLocalStorage(SEARCH_RECORD);
            if (searchRecord) {
                searchRecord = JSON.parse(searchRecord);
                if (!searchRecord.includes(key)) {
                    if (searchRecord.length < 10) {
                        searchRecord.push(key);
                    } else {
                        searchRecord[0] = key;
                    }
                }
                setLocalStorage(SEARCH_RECORD, JSON.stringify(searchRecord));
            } else {
                let temp = [];
                temp.push(key);
                setLocalStorage(SEARCH_RECORD, JSON.stringify(temp));
            }
            this.$router.push({
                path: "/product/search/result",
                query: { key: window.encodeURI(key) },
            });
        },
    },
};
</script>
<style lang="less" scoped>
.search-container {
    width: 750px;
    .search-fixed-box {
        position: fixed;
        z-index: 10;
        width: 750px;
        left: 50%;
        top: 90px;
        bottom: 0;
        margin-left: -375px;
        .associational-word-wrap {
            position: absolute;
            z-index: 20;
            width: 750px;
            height: 100%;
            > .search-bar {
                padding: 10px 20px;
                .search-box {
                    width: 710px;
                    height: 80px;
                    .search-input-box {
                        float: left;
                        width: 569px;
                        height: 75px;
                        border-top: 1px solid #666;
                        border-bottom: 1px solid #666;
                        border-left: 1px solid #666;
                        > input {
                            padding: 0 30px;
                            width: 509px;
                            height: 78px;
                            background-color: transparent;
                            border: none;
                            font-size: 26px;
                            line-height: 78px;
                            color: #333;
                        }
                    }
                    .search-button {
                        float: right;
                        width: 138px;
                        height: 80px;
                        background-color: @theme-color;
                        font-size: 28px;
                        line-height: 80px;
                        color: #fff;
                        text-align: center;
                    }
                }
            }
            > .associational-word {
                position: absolute;
                z-index: 30;
                left: 20px;
                right: 20px;
                top: 100px;
                bottom: 0;
                .associational-word-list {
                    overflow-y: auto;
                    width: 710px;
                    height: 100%;
                    .word-item {
                        overflow: hidden;
                        font-size: 28px;
                        height: 100px;
                        line-height: 100px;
                        border-bottom: 1px solid #f2f2f2;
                        color: #333;
                        &:last-child {
                            border-bottom: none;
                        }
                        .word-item-left {
                            float: left;
                            height: 100px;
                            width: 60%;
                            line-height: 100px;
                        }
                        .word-item-right {
                            float: right;
                            height: 100px;
                            width: 40%;
                            line-height: 100px;
                            text-align: right;
                            color: #999;
                        }
                    }
                }
            }
            > .record-word {
                padding: 0 20px;
                width: 710px;
                > .caption {
                    height: 70px;
                    font-size: 28px;
                    line-height: 70px;
                }
                > .recode-word-list {
                    font-size: 0px;
                    .word-item {
                        *display: inline;
                        display: inline-block;
                        *zoom: 1;
                        padding: 15px 20px;
                        margin: 0 15px 15px 0;
                        border-radius: 8px;
                        background-color: #f6f6f6;
                        font-size: 28px;
                        color: #333;
                    }
                }
            }
        }
    }
}
</style>
